/**
 * Created by andermurias on 14/7/17.
 */


export let Utils = {
  procesSvg: function (svg) {
    let processedSvg = "";
    if (svg.indexOf('preserveAspectRatio') !== -1) {
      processedSvg = svg.replace('xMidYMid meet', 'xMidYMid slice');
    } else {
      processedSvg = svg.replace('xmlns', 'preserveAspectRatio="xMidYMid slice" xmlns');
    }

    if (processedSvg.indexOf('viewBox') === -1) {
      let regexpWidth = /width="([^"]+)"/;
      let width = regexpWidth.exec(processedSvg);
      let regexpHeight = /height="([^"]+)"/;
      let height = regexpHeight.exec(processedSvg);
      processedSvg = processedSvg.replace('xmlns', 'viewBox="0 0 ' + width[1] + ' ' + height[1] + '" xmlns');
    }
    return processedSvg;
  }
}


// WEBPACK FOOTER //
// ./src/js/common/utils.js